import SocialDropdown from '../src/LikingPhotos/SocialDropdown.tsx';
export default SocialDropdown;
